import { useQuery } from '@tanstack/react-query'

import { GetUserViewModel } from '@/types/pam-api'

import { LayoutReactQueryKeys } from '@/components/header/types'

import fetchRequest from '@/app/_utils/fetch-request'
import { useJwtToken } from '@/app/_utils/session/use-jwt-token'

const useUser = (refetchOnMount = false) => {
    const { data: jwtToken, isLoading: isJwtLoading } = useJwtToken()

    const {
        data: user,
        refetch,
        isLoading: isUserLoading,
        isFetching,
        isError,
        isPending,
    } = useQuery<GetUserViewModel>({
        queryKey: [LayoutReactQueryKeys.UserInfo],
        queryFn: () =>
            fetchRequest({
                method: 'GET',
                serviceName: 'pam',
                endpoint: `/users/_current`,
            }),
        retryOnMount: false,
        refetchOnMount,
        enabled: !!jwtToken,
    })

    const userQueryLoading = isUserLoading || isPending
    const isLoading = isJwtLoading || (!!jwtToken && userQueryLoading)

    return {
        isLoggedIn: !!user,
        isLoading,
        user,
        refetch,
        isFetching,
        isError,
    }
}

export default useUser
